export const PROFILE_TEMPLATE_SLUGS = [
  'artist-link-in-bio-template',
  'developer-link-in-bio-template',
  'musician-link-in-bio-template',
  'shop-link-in-bio-template',
  'coach-link-in-bio-template',
  'portfolio-link-in-bio-template',
];

const link = (title, url) => ({ title, url, type: 'link' });

export const PROFILE_TEMPLATES = {
  'artist-link-in-bio-template': {
    label: 'Artist Profile Template',
    profile: {
      bio: 'Artwork, commissions, prints, and current projects in one place.',
      bg_color: '#FFF7ED',
      button_color: '#FF6B6B',
      link_text_color: '#FFFFFF',
      title_color: '#3C2A21',
      bio_color: '#6B5B53',
      accent_color: '#FF1E90',
    },
    links: [
      link('View my portfolio', 'https://example.com/portfolio'),
      link('Commission request form', 'https://example.com/commissions'),
      link('Print shop', 'https://example.com/shop'),
      link('Latest work on Instagram', 'https://instagram.com/'),
      link('Join my studio updates', 'https://example.com/newsletter'),
    ],
  },
  'developer-link-in-bio-template': {
    label: 'Developer Profile Template',
    profile: {
      bio: 'Projects, demos, docs, launch updates, and ways to reach me.',
      bg_color: '#EEF2FF',
      button_color: '#4F46E5',
      link_text_color: '#FFFFFF',
      title_color: '#111827',
      bio_color: '#475569',
      accent_color: '#6366F1',
    },
    links: [
      link('Try the live demo', 'https://example.com/demo'),
      link('GitHub projects', 'https://github.com/'),
      link('API docs', 'https://example.com/docs'),
      link('Product changelog', 'https://example.com/changelog'),
      link('Contact me', 'mailto:hello@example.com'),
    ],
  },
  'musician-link-in-bio-template': {
    label: 'Musician Profile Template',
    profile: {
      bio: 'New releases, shows, merch, videos, and fan updates.',
      bg_color: '#FFF1F8',
      button_color: '#FF1E90',
      link_text_color: '#FFFFFF',
      title_color: '#2F1525',
      bio_color: '#6D4A5D',
      accent_color: '#FF1E90',
    },
    links: [
      link('Stream the latest release', 'https://example.com/release'),
      link('Tour dates and tickets', 'https://example.com/tour'),
      link('Merch store', 'https://example.com/merch'),
      link('Watch on YouTube', 'https://youtube.com/'),
      link('Join fan updates', 'https://example.com/fans'),
    ],
  },
  'shop-link-in-bio-template': {
    label: 'Shop Page Template',
    profile: {
      bio: 'Featured products, current offers, and checkout links.',
      bg_color: '#FFFBEB',
      button_color: '#F59E0B',
      link_text_color: '#3C2A21',
      title_color: '#3C2A21',
      bio_color: '#765C2F',
      accent_color: '#F59E0B',
      shop_title: 'Featured products',
      shop_description: 'Start with the offer you want visitors to see first.',
      shop_cta: 'Shop now',
    },
    links: [
      link('Shop the new drop', 'https://example.com/shop'),
      link('Best-selling product', 'https://example.com/product'),
      link('Digital downloads', 'https://example.com/downloads'),
      link('Customer reviews', 'https://example.com/reviews'),
      link('Ask a product question', 'mailto:hello@example.com'),
    ],
  },
  'coach-link-in-bio-template': {
    label: 'Coach Profile Template',
    profile: {
      bio: 'Book a call, explore programs, and get practical resources.',
      bg_color: '#ECFDF5',
      button_color: '#10B981',
      link_text_color: '#FFFFFF',
      title_color: '#064E3B',
      bio_color: '#047857',
      accent_color: '#10B981',
    },
    links: [
      link('Book a discovery call', 'https://example.com/book'),
      link('Explore programs', 'https://example.com/programs'),
      link('Client results', 'https://example.com/results'),
      link('Download the free guide', 'https://example.com/guide'),
      link('Join the newsletter', 'https://example.com/newsletter'),
    ],
  },
  'portfolio-link-in-bio-template': {
    label: 'Portfolio Profile Template',
    profile: {
      bio: 'Selected work, case studies, resume, writing, and contact.',
      bg_color: '#F8FAFC',
      button_color: '#111827',
      link_text_color: '#FFFFFF',
      title_color: '#111827',
      bio_color: '#475569',
      accent_color: '#2563EB',
    },
    links: [
      link('Selected work', 'https://example.com/work'),
      link('Case studies', 'https://example.com/cases'),
      link('Resume', 'https://example.com/resume'),
      link('Writing', 'https://example.com/writing'),
      link('Contact', 'mailto:hello@example.com'),
    ],
  },
};

export const isKnownProfileTemplate = (slug) =>
  PROFILE_TEMPLATE_SLUGS.includes(slug);

export const getProfileTemplate = (slug) =>
  PROFILE_TEMPLATES[slug] || null;

export const buildTemplateSignupPath = (slug) => {
  const params = new URLSearchParams({ signup: 'true' });
  if (isKnownProfileTemplate(slug)) params.set('template', slug);
  return `/login?${params.toString()}`;
};
